import { pinnedMessageFocusSlice } from '../store/slices/pinnedMessageFocusSlice';

export const pinnedMessageInfocus = pinnedMessageFocusSlice.reducer;
